import React, { FunctionComponent } from "react";
import Image from "next/image";
import InfyButton from "../InfyButton/InfyButton";

interface IProps {
  responseScore: {
    correctAnswers: number;
    correctCount: number;
    incorrectCount: number;
    totalEvaluated: number;
    totalQuestions: number;
    wrongAnswers: number;
  };
}

const Result: FunctionComponent<IProps> = ({ responseScore }) => {
  const { correctCount, totalQuestions } = responseScore || {};
  return (
    <div className="h-screen flex flex-col items-center justify-center p-8">
      <div className="h-52 md:h-80 w-52 md:w-80 relative">
        <Image src="/boardinfinity-icons/Success.svg" alt="error" layout="fill" objectFit="contain" />
      </div>
      {totalQuestions > 0 && (
        <h1 className="text-xl md:text-2xl font-semibold text-neutral-12">
          You Scored {correctCount || 0}/{totalQuestions} Points{" "}
        </h1>
      )}

      <p className="text-neutral-9 text-center">Your responses have been recorded. You may continue with the video.</p>

      <InfyButton
        type="primary"
        bicolor="primary"
        onClick={() => {
          window?.parent?.postMessage({ action: "resumeVideo" }, "*");
        }}
      >
        Resume Video
      </InfyButton>
    </div>
  );
};

export default Result;
